/* Ollyball: stop off-screen and hidden videos from streaming.
   Above-the-fold video is left alone. Below-the-fold video loads when
   it scrolls close; hidden video loads only if it becomes visible. */
(function () {
  if (!window.IntersectionObserver) return;

  function stash(v) {
    if (v.getAttribute('data-ol-stashed')) return;
    var list = [];
    var sources = v.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      list.push(sources[i].getAttribute('src') || '');
      sources[i].removeAttribute('src');
    }
    if (v.getAttribute('src')) {
      v.setAttribute('data-ol-selfsrc', v.getAttribute('src'));
      v.removeAttribute('src');
    }
    v.setAttribute('data-ol-srcs', list.join('|'));
    v.setAttribute('data-ol-stashed', '1');
    v.removeAttribute('autoplay');
    v.autoplay = false;
    v.preload = 'none';
    try { v.pause(); v.load(); } catch (e) {}
  }

  function revive(v) {
    if (!v.getAttribute('data-ol-stashed') || v.getAttribute('data-ol-live')) return;
    var list = (v.getAttribute('data-ol-srcs') || '').split('|');
    var sources = v.querySelectorAll('source');
    for (var i = 0; i < sources.length; i++) {
      if (list[i]) sources[i].setAttribute('src', list[i]);
    }
    var self = v.getAttribute('data-ol-selfsrc');
    if (self) v.setAttribute('src', self);
    v.setAttribute('data-ol-live', '1');
    v.preload = 'metadata';
    try {
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }

  function start() {
    var vids = document.querySelectorAll('video');
    if (!vids.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          revive(entries[i].target);
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '400px 0px' });

    var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target;
        var b = el.getBoundingClientRect();
        if (b.width > 0 && b.height > 0) {
          ro.unobserve(el);
          io.observe(el);
        }
      }
    }) : null;

    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      var box = v.getBoundingClientRect();
      var hidden = box.width === 0 || box.height === 0;
      var below = box.top > (window.innerHeight || 0);

      if (hidden) {
        stash(v);
        if (ro) ro.observe(v); else io.observe(v);
      } else if (below) {
        stash(v);
        io.observe(v);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
